import { StatusEnum } from "@ds/model/status-model";

// Note: StatusEnum.Incomplete covers deferred and other states relative to backend logic
export const DEPLOYMENT_VALID_REPORT_STATUSES = [StatusEnum.Incomplete, StatusEnum.Succeeded];
export const DEPLOYMENT_VALID_STATUSES = [StatusEnum.Pending, StatusEnum.Scheduled];

export const isAllowedToDelete = (deployments: Deployment[]) => {
  if (!deployments.length) {
    return false;
  }

  const availableStatuses: Status[] = [StatusEnum.Pending, StatusEnum.Scheduled, StatusEnum.Failed];
  return deployments.every(({ status }) => availableStatuses.includes(status));
};
